


const SectionTitle = ({ title, customClass, tag }) => {

  if (tag === 'h1') {
    return (
      <h1 className={`title ${customClass ? customClass : ''}  `} dangerouslySetInnerHTML={{ __html: title }} />
    )
  }
  else if (tag === 'h2') {
    return (
      <h2 className={`title ${customClass ? customClass : ''}  `} dangerouslySetInnerHTML={{ __html: title }} />
    )
  }
  else if (tag === 'h3') {
    return (
      <h3 className={`title ${customClass ? customClass : ''}  `} dangerouslySetInnerHTML={{ __html: title }} />
    )
  } else if (tag == 'p') {
    return (
      <p className={`title ${customClass ? customClass : ''}  `} dangerouslySetInnerHTML={{ __html: title }} />
    )
  } else if (tag === 'div') {
    return (
      <div className={`title ${customClass ? customClass : ''}  `} dangerouslySetInnerHTML={{ __html: title }} />
    )
  } else {
    return (
      <div className={`title ${customClass ? customClass : ''}  `} dangerouslySetInnerHTML={{ __html: title }} />
    )
  }

}

export default SectionTitle
